import script from "./TextArea.vue?vue&type=script&lang=ts&setup=true"
export * from "./TextArea.vue?vue&type=script&lang=ts&setup=true"

import "./TextArea.vue?vue&type=style&index=0&id=017a3e62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-017a3e62"]])

export default __exports__